<template>

  <q-card class="full-width">
    <q-card-section>
      <div class="text-h6">Edit db field</div>
    </q-card-section>

    <q-card-section class="q-pt-none">

      <q-form ref="dbFieldForm" @submit="onSaveDbField">

        <div class="row">
        <q-input
            class="col"
            v-model.trim="mutate(editField).name"
            label="Field name *"
            lazy-rules
            :rules="[ val => val && val.length > 0 || 'Please type something']"
        />

        <q-checkbox v-model="mutate(editField).key_field" :true-value="1" :false-value="0" label="Key field"/>
        </div>

        <q-select
            v-model="mutate(editField).type"
            label="Field type *"
            lazy-rules
            :rules="[ val => val && val.length > 0 || 'Please type something']"
            map-options
            emit-value
            :options="dataTypes"
        />

        <template v-if="allowDefaultValue">
          <q-select
            v-if="mutate(editField).type === 'bool'"
            label="Default value"
            v-model.number="mutate(editField).default_value"
            :options="booleanValues"
            map-options
            emit-value
          />
          <q-input
            v-else
            v-model="mutate(editField).default_value"
            label="Default value"
          />
        </template>

        <q-input
          v-model="mutate(editField).description"
          label="Field description"
          type="textarea"
          autogrow
        />

        <db-permission-settings v-model="mutate(editField).permissions" :permission-list="['read', 'write']"/>

        <q-separator spaced/>

        <div>
          <q-btn label="Save" type="submit" color="primary"/>
        </div>
      </q-form>

    </q-card-section>

  </q-card>

</template>

<script>

import {DbTableField} from "@/../../common/db/DbTableField";
import {nanoid} from "nanoid";
import DbPermissionSettings from "@/pages/workspace/dbs/DbPermissionSettings.vue";
import {AppModule} from '../../../../../common/db/AppModule';

export default {
  name: "TableFieldForm",
  components: {DbPermissionSettings},
  props: ['editField'],
  emits: ['saved'],

  data() {
    return {
      module: null,
      booleanValues: [
        {value: 1, label: 'True'},
        {value: 0, label: 'False'},
      ],
    }
  },

  computed: {
    /**
     * Computed property to get the module ID from the route parameters.
     * @returns {string} The module ID.
     */
    moduleId() {
      return this.$route.params.module_id;
    },

    /**
     * Computed property to get the data types based on the module type.
     * Filters out 'textsearch' if the module type is not 'server'.
     * @returns {Array} The filtered data types.
     */
    dataTypes() {
      if (this.module?.type !== 'server') {
        return this.globals.options.db_data_types.filter((v) => v.value !== 'textsearch');
      }

      return this.globals.options.db_data_types;
    },

    /**
     * Computed property to determine if the default value input should be shown.
     * The default value input is shown for specific field types.
     * @returns {boolean} True if the default value input should be shown, false otherwise.
     */
    allowDefaultValue() {
      return [
        'secret',
        'string',
        'text',
        'int',
        'float',
        'bool',
        'datetime',
      ].includes(this.editField.type);
    },
  },

  async mounted() {
    // Subscribe to the module
    await AppModule.remote().subscribe('module', {id: this.moduleId});

    // Get the module
    this.module = await AppModule.find(this.moduleId);
  },

  methods: {

    /**
     * On form submit
     * @return {Promise<void>}
     */
    async onSaveDbField() {

      if(!this.editField.id) {
        this.mutate(this.editField).unique_id = nanoid(10);
      }

      // Update
      await DbTableField.remote().save(this.editField)

      // Hide dialog
      this.$emit('saved')
    }
  }
}

</script>
